var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.item.style)?_c('span',{style:(_vm.item.style)},[_c('i',{staticClass:"fas fa-circle"})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v("\n    "+_vm._s(_vm.item.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }